import { TradingPanel } from '@/features/trading/trading-panel';

// Legacy set no page <title> (default app title kept deliberately);
// the "Trading" breadcrumb/nav entry lives in routing.
const TradingPage = () => (
  <div className="flex w-full flex-col gap-4">
    <h1 className="text-3xl font-semibold">Trading</h1>
    <TradingPanel />
  </div>
);
TradingPage.displayName = 'TradingPage';

export default TradingPage;
